export const replaceWords = (
  text: string,
  replacements: { [key: string]: string }
): string => {
  return text.replace(/\[(.+?)\]/g, (match, p1) => {
    const replacement = replacements[p1];
    return replacement !== undefined ? replacement : match;
  });
};
